import React from 'react'

interface NumberInputProps {
  value: number
  onChange: (value: number) => void
  min?: number
  max?: number
  step?: number
  className?: string
  width?: string
  height?: string
}

const NumberInput: React.FC<NumberInputProps> = ({
  value,
  onChange,
  min = 1,
  max = 20,
  step = 1,
  className = '',
  width = 'w-[168px]',
  height = 'h-[28px]',
}) => {
  const handleDecrease = () => {
    const newValue = Math.max(min, Math.round((value - step) * 10) / 10)
    onChange(newValue)
  }

  const handleIncrease = () => {
    const newValue = Math.min(max, Math.round((value + step) * 10) / 10)
    onChange(newValue)
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value.replace(/[^0-9.]/g, '')
    const numValue = parseFloat(inputValue) || min
    const clampedValue = Math.max(
      min,
      Math.min(max, Math.round(numValue * 10) / 10)
    )
    onChange(clampedValue)
  }

  return (
    <div
      className={`flex items-center ${width} ${height} border border-[#8752FF] rounded-[4px] ${className}`}
    >
      <button
        type="button"
        onClick={handleDecrease}
        className="w-8 h-full bg-[#F5F7FA] flex items-center justify-center hover:bg-gray-100 text-[#606266] rounded-l-[4px] border-r border-[#E4E7ED] flex-shrink-0"
      >
        -
      </button>
      <input
        type="text"
        value={value}
        onChange={handleInputChange}
        className="flex-1 h-full text-center border-none outline-none bg-transparent text-m min-w-0"
      />
      <button
        type="button"
        onClick={handleIncrease}
        className="w-8 h-full bg-[#F5F7FA] flex items-center justify-center hover:bg-gray-100 text-[#606266] rounded-r-[4px] border-l border-[#E4E7ED] flex-shrink-0"
      >
        +
      </button>
    </div>
  )
}

export default NumberInput
